import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { storeUserInfo } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { onLanguageChange } from '@vantiva-sa/homesight_humaui/Utilities/Translation';
import { DefaultLanguage } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import { useApiQuery } from './useApiQuery';

const useUserInfo = ({ useruuid, queryOptions = {} }) => {
  const dispatch = useDispatch();
  const currentUser = useSelector(getCurrentUser);
  const currentUseruuid = useMemo(() => currentUser?.useruuid, [currentUser]);

  const trans = useSelector(translator);
  const userApi = useSelector((state) => state.apis.userApi);

  return useApiQuery(
    ['userInfo', useruuid],
    () =>
      new Promise((resolve, reject) => {
        userApi.apiClient.callApi(
          '/hacloud/api/v1/user/{useruuid}/info',
          'GET',
          { useruuid },
          { config: true },
          { 'Cache-Control': 'no-cache' },
          {},
          null,
          [],
          [],
          ['application/json'],
          Object,
          null,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              dispatch(storeUserInfo(data?.user));
              if (currentUseruuid === data?.user?.useruuid) {
                onLanguageChange(data?.user?.locale || DefaultLanguage);
              }
              resolve(data?.user);
            },
            errorCallback: () => {
              reject([]);
            },
          })
        );
      }),
    { enabled: !!useruuid, ...queryOptions }
  );
};

export default useUserInfo;
